import React from 'react'
import { Route } from 'react-router-dom'
import { omit } from './helpers/generalHelpers'
// import routes
import * as routes from './Routes/Routes'
import * as dashboardRoutes from './Routes/dashboardRoutes'
import * as registrationRoutes from './Routes/registrationRouts'
// import * as formMakerRoutes from './Routes/formMakerRoutes';
import PrivateRoute from './Routes/PrivateRoute'
import RedirectIfAuthRoutes from './Routes/RedirectIfAuthRoutes'

const wrapperTypes = {
  privateRoute: PrivateRoute,
  redirectIfAuthRoute: RedirectIfAuthRoutes,
  regular: Route,
}

const appRoutesDef = [
  {
    path: '/',
    exact: true,
    type: 'regular',
    component: routes.HomePage,
  },
  {
    path: '/u',
    type: 'privateRoute',
    component: dashboardRoutes.Dashboard,
  },
  {
    path: '/oauth2/exchange',
    type: 'redirectIfAuthRoute',
    component: registrationRoutes.Register,
  },
  {
    path: '/account',
    type: 'redirectIfAuthRoute',
    component: registrationRoutes.Register,
  },
  {
    path: '/templates',
    type: 'regular',
    component: routes.Templates,
  },
  {
    path: '/d/:formSlug/:tempType/:tempSlug',
    type: 'regular',
    component: routes.TemplateDuplicator,
  },
  // {
  //   path: '/formMaker',
  //   type: 'redirectIfAuthRoute',
  //   component: formMakerRoutes.UnregisteredFormMaker
  // },
  {
    path: '/w/:workspace/forms/create',
    type: 'privateRoute',
    component: routes.BlankFormCreator,
  },

  {
    component: routes.NotFoundPage,
    type: 'regular',
  },
]

const appRoutes = appRoutesDef.map((route, index) => {
  const Wrapper = wrapperTypes[route.type]
  return <Wrapper {...omit(['type'])(route)} key={index} />
})

export default appRoutes
